import axios from '../axios/AxiosInstance';
export async function analyzeCandidateCv(file) {
  for(let attempt=0;attempt<2;attempt++) {
    const body=new FormData();body.append('file',file);
    try {return (await axios.post('tempworker-candidate/analyze-cv',body,{timeout:120000})).data;}
    catch(error) {
      const transient=!error.response || [502,503,504].includes(error.response.status);
      if(attempt===0 && transient && error.code!=='ECONNABORTED') {await new Promise(resolve=>setTimeout(resolve,1000));continue;}
      throw error;
    }
  }
}
export function cvAnalysisError(error) {
  const detail=error.response?.data?.message;
  if(detail)return Array.isArray(detail)?detail.join(' '):detail;
  if(error.code==='ECONNABORTED')return 'L’analyse du CV a dépassé le délai prévu. Cliquez sur « Relancer l’analyse du CV ».';
  if(error.response?.status===401)return 'Votre session a expiré. Reconnectez-vous pour analyser le CV.';
  return 'Connexion au service d’analyse impossible. Vos qualifications sont conservées. Cliquez sur « Relancer l’analyse du CV » pour réessayer.';
}
